<template>
  <div>
    <div id="error-box" v-if="errored" class="container">
      <div class="row">
        <h1>
          <i class="fas  fa-exclamation-triangle" aria-hidden="true"></i> Error
        </h1>
      </div>
      <br />
      <div>{{ message }}</div>
      <br />
      <button
        type="submit"
        class="form-control btn btn-warning"
        @click="$router.push('/')"
      >
        <span class="glyphicon glyphicon-off"></span>Ok
      </button>
    </div>

    <div v-else-if="loading">Loading please wait</div>
    <AccountActivation v-else-if="request_type == 1" :request_id="request_id" />
    <PasswordReset v-else-if="request_type == 3" :request_id="request_id" />
  </div>
</template>

<script>
import axios from "axios";
import PasswordReset from "./PasswordReset.vue";
import AccountActivation from "./AccountActivation.vue";

export default {
  data() {
    return {
      loading: true,
      errored: false,
      request_type: 0,
      request_id: "",
      message: "",
    };
  },
  components: {
    AccountActivation,
    PasswordReset,
  },

  mounted() {
    axios({
      url: "AUTH/V1/REQUEST/" + this.$route.params.id,
      method: "GET",
    })
      .then((resp) => {
        this.message = resp; //.data.description;
        this.request_type = resp.data.request.type;
        this.request_id = resp.data.request.id;
      })
      .catch((err) => {
        this.message = err.response.data.fault.detail;
        this.errored = true;
      })
      .finally(() => (this.loading = false));
  },
};
</script>
